import React from 'react'
import { Route, IndexRoute, Redirect } from 'react-router'

import Authenticated from 'internal-components/src/containers/Authenticated'
import SignupRetrieval from 'internal-components/src/containers/SignupRetrieval'

import CoreLayout from '../layouts/CoreLayout'
import SignupWorkflow from '../containers/Signup/Workflow'

import MspDashboardView from '../views/Msp/DashboardView'
import MspFinishedView from '../views/Msp/FinishedView'
import MspNewSignupView from '../views/Msp/NewSignupView'

import SignupView from '../views/Signup/SignupView'

import AccountView from '../views/SignupForm/AccountView'
import DetailView from '../views/SignupForm/DetailView'
import FinishedView from '../views/SignupForm/FinishedView'
import IncomingView from '../views/SignupForm/IncomingView'
import LoginView from '../views/Authentication/LoginView'
import LogoutView from '../views/Authentication/LogoutView'
import NotFoundView from '../views/NotFoundView'
import OfferView from '../views/SignupForm/OfferView'
import StartView from '../views/SignupForm/StartView'
import SummaryView from '../views/SignupForm/SummaryView'

export default () => (
  <Route path="/" component={CoreLayout}>
    <Route path="/login" component={LoginView} />
    <Route path="/logout" component={LogoutView} />

    <IndexRoute component={StartView} />
    <Route path="/incoming" component={IncomingView} />

    <Route component={Authenticated}>
      <Redirect path="/msp" to="/partner" />
      <Redirect path="/msp/new" to="/partner/new" />
      <Redirect
        path="/msp/finished/:reference"
        to="/partner/finished/:reference"
      />

      <Route path="/partner" component={MspDashboardView} />
      <Route path="/partner/new" component={MspNewSignupView} />

      <Route component={SignupRetrieval}>
        <Route
          path="/partner/finished/:reference"
          component={MspFinishedView}
        />
      </Route>
    </Route>

    <Route component={SignupWorkflow}>
      <Route path="/offer" component={OfferView} />
      <Route path="/account" component={AccountView} />
      <Route path="/detail" component={DetailView} />
      <Route path="/summary" component={SummaryView} />
    </Route>

    <Route component={SignupRetrieval}>
      <Route path="/finished/:reference" component={FinishedView} />
      <Route path="/signup/:reference" component={SignupView} />
    </Route>

    <Route path="*" exact={true} component={NotFoundView} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/index.jsx